var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{attrs:{"variant":"secondary"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.addHeading($event)}}},[_vm._v("Add Heading")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }